export enum TaskFilter {
    All, OnlyGood, OnlyVeryGoodVeryBad, OnlyVeryGood
}
